import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2585f720"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Name", -1))
const _hoisted_2 = { class: "middle" }
const _hoisted_3 = { class: "edit-rating" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Last Edited", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Rating", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Function Group", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_naming_advice = _resolveComponent("naming-advice")!
  const _component_select_input = _resolveComponent("select-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", null, [
      _createVNode(_component_text_input, {
        type: "text",
        id: "name",
        value: _ctx.profile.name,
        onSetData: _ctx.setName
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["value", "onSetData"])
    ]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_input, {
          type: "text",
          id: "lastEdited",
          disabled: true,
          value: _ctx.lastEdited
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_text_input, {
          type: "text",
          id: "rating",
          disabled: true,
          value: _ctx.profile.rating.toString()
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_naming_advice, { class: "advice" })
    ]),
    _createElementVNode("section", null, [
      _hoisted_6,
      _createVNode(_component_select_input, {
        onOnSelect: _ctx.setFunctionGroup,
        value: _ctx.functionGroupValue,
        options: _ctx.functionGroups,
        placeholder: "Select a Function Group for this Profile..."
      }, null, 8, ["onOnSelect", "value", "options"])
    ])
  ]))
}